import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { oktaAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';
import techdocsViewsModule from '@internal/plugin-techdocs-views';
import nucleusModule from '@internal/plugin-nucleus';

import { navModule } from './modules/nav';
import { argocdContentExtension } from './modules/argocd';
import githubActionsExtension, { githubActionsApi } from './modules/github-actions';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { dynamicContextPickerExtension } from './scaffolder';

const isDev = process.env.NODE_ENV === 'development';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      isDev ? (
        <SignInPage {...props} auto providers={['guest']} />
      ) : (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'okta-auth-provider',
            title: 'Okta',
            message: 'Sign in using your Hyland Okta account',
            apiRef: oktaAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    techDocsMermaidAddonModule,
    techdocsViewsModule,
    nucleusModule,
    kubernetesPlugin,
    createFrontendModule({
      pluginId: 'catalog',
      extensions: [argocdContentExtension, githubActionsExtension, githubActionsApi],
    }),
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
    createFrontendModule({
      pluginId: 'scaffolder',
      extensions: [dynamicContextPickerExtension],
    }),
  ],
});
